<template>
  <div class="inner-layout">
    <Header />
    <BreadCrumbs diver="/" />
    <ErrorAlert />
    <main class="main-white">
      <v-container>
        <v-row>
          <v-col cols="12" v-if="showMenu">
            <v-tabs class="tabs">
              <v-tab :to="{ name: RouteName.STATEMENTS }">
                {{ RouteText.STATEMENTS }}
              </v-tab>
              <v-tab :to="{ name: RouteName.STATEMENTS_JOINT }">
                {{ RouteText.STATEMENTS_JOINT }}
              </v-tab>
              <v-tab v-if="isOrganizationStatementsVisible" :to="{ name: RouteName.ORGANIZATION_STATEMENTS }">
                {{ RouteText.ORGANIZATION_STATEMENTS }}
              </v-tab>
              <v-tab :to="{ name: RouteName.PERSONAL_DETAILS }">
                {{ RouteText.PERSONAL_DETAILS }}
              </v-tab>
              <v-tab :to="{ name: RouteName.DOCUMENTS_AND_DATA }">
                {{ RouteText.DOCUMENTS_AND_DATA }}
              </v-tab>
              <v-tab :to="{ name: RouteName.NOTIFICATIONS }">
                {{ RouteText.NOTIFICATIONS }}
              </v-tab>
              <v-tab :to="{ name: RouteName.NOTIFICATIONS_DOCUMENTS }">
                {{ RouteText.NOTIFICATIONS_DOCUMENTS }}
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </main>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/base/Footer.vue';
import Header from '@/components/base/Header.vue';
import BreadCrumbs from '@/components/base/BreadCrumbs.vue';
import ErrorAlert from '@/components/base/ErrorAlert.vue';
import { RouteText, RouteName } from '@/router';
import { AuthModule } from '@/store/modules/auth';
import { Role } from '@/utils/dictionaries';

export default {
  name: 'Inner',
  components: {
    BreadCrumbs,
    Header,
    Footer,
    ErrorAlert,
  },
  data: () => ({
    RouteText,
    RouteName,
  }),
  computed: {
    showMenu() {
      return this.$route.meta.menu;
    },
    isOrganizationStatementsVisible() {
      return AuthModule.roleType === Role.ORGANIZATION || AuthModule.isBusinessman;
    }
  },
};
</script>

<style lang="scss">
.tabs {
  padding-top: 8px;

  .v-tabs-bar::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background-color: $color-grey;
  }

  .v-tab {
    font-size: $font-size-base;
    text-transform: none;
    letter-spacing: normal;
    padding-left: 0;
    padding-right: 0;
    margin-right: 32px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
